module.exports = __webpack_public_path__ + "img/Notification.7b203b3c.jpg";